import { m } from 'framer-motion';

import { Button, Container, Typography } from '@mui/material';

import { Helmet } from 'react-helmet-async';

import { Link } from 'react-router-dom';
import { PATH_SETTINGS } from 'src/Router/paths';
import { ComingSoonIllustration } from 'src/assets/illustrations';
import { MotionContainer, varBounce } from 'src/components/animate';
import { useLocales } from 'src/locales';
import { Rule } from 'src/requests/roles.requests';
import { usePermission } from 'src/utils/hasPermission';

export function WorkspaceLocked() {
  const { hasPermission } = usePermission();
  const { translate } = useLocales();

  return (
    <>
      <Helmet>
        <title>{translate('shared.labels.locked')} | Copera.ai</title>
      </Helmet>

      <Container component={MotionContainer} sx={{ textAlign: 'center' }}>
        <m.div variants={varBounce().in}>
          <Typography variant="h3" paragraph>
            {translate('locked_workspace.heading')}
          </Typography>
        </m.div>

        <m.div variants={varBounce().in}>
          <Typography sx={{ color: 'text.secondary' }}>
            {translate('locked_workspace.description')}
          </Typography>
        </m.div>

        <m.div variants={varBounce().in}>
          <ComingSoonIllustration sx={{ height: 260, my: { xs: 5, sm: 10 } }} />
        </m.div>

        {hasPermission(Rule.ADMINISTRATOR) && (
          <m.div variants={varBounce().in}>
            <Button
              variant="contained"
              component={Link}
              to={PATH_SETTINGS.workspace.billing}
            >
              {translate('free_plan_exceeded.go_to_billing')}
            </Button>
          </m.div>
        )}
      </Container>
    </>
  );
}
